// extracted by mini-css-extract-plugin
export var background = "bL_x";
export var backgroundContainer = "bL_fj";
export var bottomWave = "bL_cj";
export var buttons = "bL_ct";
export var container = "bL_k";
export var content = "bL_bY";
export var icon = "bL_bz";
export var iconContainer = "bL_bP";
export var middleWave = "bL_ch";
export var negativeTop = "bL_hr";
export var overlap = "bL_ht";
export var section = "bL_b";
export var selected = "bL_bg";
export var tab = "bL_fh";
export var tabText = "bL_fg";
export var title = "bL_f";
export var topWave = "bL_hs";